var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDirection = function SvgIconDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M16.895 17.645h-4.243a.75.75 0 1 1 0-1.5h2.432L10 11.06l-5.084 5.084H7.35a.75.75 0 1 1 0 1.5H3.106a.75.75 0 0 1-.75-.75V12.65a.75.75 0 1 1 1.5 0v2.433L8.94 10 3.856 4.917v2.432a.75.75 0 1 1-1.5 0V3.106c0-.41.337-.75.75-.75H7.35a.75.75 0 1 1 0 1.5H4.916L10 8.94l5.084-5.084h-2.432a.75.75 0 1 1 0-1.5h4.243c.41 0 .75.337.75.75V7.35a.75.75 0 1 1-1.5 0V4.917L11.06 10l5.084 5.084v-2.432a.75.75 0 1 1 1.5 0v4.243c0 .413-.34.75-.75.75"
  })));
};
export default SvgIconDirection;